var BrowseParsedParamsHelper, DealsSearchParamsHelper, getFacetGroupFiltersParam, initializeParams, unfilteredParams;

BrowseParsedParamsHelper = require('../../../browse/frontend/helpers/parsed_params');

module.exports = DealsSearchParamsHelper = {
  getBaseParams: function(options) {
    var params, ref, ref1;
    if (options == null) {
      options = {};
    }
    params = initializeParams(options);
    params.division = Cookie.get('division');
    params.facet_group_filters = getFacetGroupFiltersParam(options);
    if ((ref = Groupon.RefinementBar) != null ? ref.isLeftBarVisible : void 0) {
      params.isRefinementBarDisplayed = true;
    }
    params.isSeoEnabled = Groupon.isSeoEnabled;
    params.collectionType = (ref1 = Groupon.collection) != null ? ref1.type : void 0;
    if (params.category == null) {
      params.category = 'all';
    }
    if (Groupon.isSeoEnabled) {
      _.extend(params, BrowseParsedParamsHelper.getParsedParams());
    }
    if (options.omitSearch) {
      delete params.query;
    }
    if (params.collectionType) {
      params.query = Groupon.collection.id;
    }
    return params;
  }
};

initializeParams = function(options) {
  var parsedParams;
  if (options.params != null) {
    return _.clone(options.params);
  }
  parsedParams = Groupon.Utils.unparam();
  if (options.unfiltered) {
    return unfilteredParams(parsedParams);
  }
  return parsedParams;
};

unfilteredParams = function(params) {
  return _.pick(params, 'page', 'sort');
};

getFacetGroupFiltersParam = function(options) {
  if (options.facet_group_filters != null) {
    return options.facet_group_filters;
  } else if (!Groupon.refinementUiPageData) {
    if (Groupon.inRAPI) {
      return 'topcategory|category|subcategory|subcategory2,deal_type';
    } else {
      return 'topcategory|category|category2|category3;deal_type;city|neighborhood';
    }
  }
};

//# sourceMappingURL=data:application/json;base64,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
